var BrowseParsedParamsHelper, DealsSearchParamsHelper, getFacetGroupFiltersParam, initializeParams, unfilteredParams;

BrowseParsedParamsHelper = require('../../../browse/frontend/helpers/parsed_params');

module.exports = DealsSearchParamsHelper = {
  getBaseParams: function(options) {
    var params, ref, ref1;
    if (options == null) {
      options = {};
    }
    params = initializeParams(options);
    params.division = Cookie.get('division');
    params.facet_group_filters = getFacetGroupFiltersParam(options);
    if ((ref = Groupon.RefinementBar) != null ? ref.isLeftBarVisible : void 0) {
      params.isRefinementBarDisplayed = true;
    }
    params.isSeoEnabled = Groupon.isSeoEnabled;
    params.collectionType = (ref1 = Groupon.collection) != null ? ref1.type : void 0;
    if (params.category == null) {
      params.category = 'all';
    }
    if (Groupon.isSeoEnabled) {
      _.extend(params, BrowseParsedParamsHelper.getParsedParams());
    }
    if (options.omitSearch) {
      delete params.query;
    }
    if (params.collectionType) {
      params.query = Groupon.collection.id;
    }
    return params;
  }
};

initializeParams = function(options) {
  var parsedParams;
  if (options.params != null) {
    return _.clone(options.params);
  }
  parsedParams = Groupon.Utils.unparam();
  if (options.unfiltered) {
    return unfilteredParams(parsedParams);
  }
  return parsedParams;
};

unfilteredParams = function(params) {
  return _.pick(params, 'page', 'sort');
};

getFacetGroupFiltersParam = function(options) {
  if (options.facet_group_filters != null) {
    return options.facet_group_filters;
  } else if (!Groupon.refinementUiPageData) {
    if (Groupon.inRAPI) {
      return 'topcategory|category|subcategory|subcategory2,deal_type';
    } else {
      return 'topcategory|category|category2|category3;deal_type;city|neighborhood';
    }
  }
};

//# sourceMappingURL=data:application/json;base64,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
